/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Search_Scope_AllInputs */

const en_explorer_search_scope_all = /** @type {(inputs: Explorer_Search_Scope_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const fr_explorer_search_scope_all = /** @type {(inputs: Explorer_Search_Scope_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const de_explorer_search_scope_all = /** @type {(inputs: Explorer_Search_Scope_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const it_explorer_search_scope_all = /** @type {(inputs: Explorer_Search_Scope_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const ru_explorer_search_scope_all = /** @type {(inputs: Explorer_Search_Scope_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const es_explorer_search_scope_all = /** @type {(inputs: Explorer_Search_Scope_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const zh_cn2_explorer_search_scope_all = /** @type {(inputs: Explorer_Search_Scope_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const ja_explorer_search_scope_all = /** @type {(inputs: Explorer_Search_Scope_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const hi_explorer_search_scope_all = /** @type {(inputs: Explorer_Search_Scope_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

const pt_pt2_explorer_search_scope_all = /** @type {(inputs: Explorer_Search_Scope_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All`)
};

/**
* | output |
* | --- |
* | "All" |
*
* @param {Explorer_Search_Scope_AllInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_search_scope_all = /** @type {((inputs?: Explorer_Search_Scope_AllInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Search_Scope_AllInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_search_scope_all(inputs)
	if (locale === "de") return de_explorer_search_scope_all(inputs)
	if (locale === "it") return it_explorer_search_scope_all(inputs)
	if (locale === "ru") return ru_explorer_search_scope_all(inputs)
	if (locale === "es") return es_explorer_search_scope_all(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_search_scope_all(inputs)
	if (locale === "ja") return ja_explorer_search_scope_all(inputs)
	if (locale === "hi") return hi_explorer_search_scope_all(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_search_scope_all(inputs)
	return en_explorer_search_scope_all(inputs)
});